module.exports = __webpack_public_path__ + "img/Juan.Leguizamon.3ce845f0.jpg";